import Vue from 'vue';
import WebFontLoader from 'webfontloader';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/axios-config';
import './scss/main.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),

  created() {
    WebFontLoader.load({
        typekit: {
            id: 'wue0tyi'
        },
        google: {
            families: ['Work Sans:100,300,400,600,700&display=swap']
        }        
    });
},
}).$mount('#app');
